module.exports = __webpack_public_path__ + "static/img/cont_makeup_01.f990525.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/images/cont_makeup_01.png
// module id = Jpq3
// module chunks = 0